import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Variant } from 'theme/enums';

import { HeaderRowList } from './HeaderRowList';

interface IProps {
  initialHeaderRowIndex: number;
  onSelectHeaderRowClick: (headerRowIndex: number) => void;
}

export const SelectHeaderRowButton = ({
  initialHeaderRowIndex,
  onSelectHeaderRowClick,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <Button
        text={t('buttonLabelSelectHeaderRow')}
        variant={Variant.SOFT}
        onClick={() => setIsOpen(true)}
        sx={{ zIndex: 1 }}
      />

      <HeaderRowList
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        initialHeaderRowIndex={initialHeaderRowIndex}
        onSelectHeaderRowClick={onSelectHeaderRowClick}
      />
    </>
  );
};
